module.exports = require("github-version-checker");